module.exports = __webpack_public_path__ + "static/media/grains_3.09b1889f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/grains/grains_3.csv
// module id = 731
// module chunks = 0